import {useHistory, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {fullTimeToShort} from "../../../lib/utils/format";
import i18next from "i18next";
import {StringParam, useQueryParam} from "use-query-params";
import {Loader} from "../../generic/loader";
import {DataTable} from "../../generic/tables";
import {Col, Row} from "reactstrap";
import {useOrdersApi} from "../../../lib/api/orders";
import {getSlotSet} from "../../common/formElements/ProductOrdersList/fieldSets";
import '../../common/formElements/ProductOrdersList/style.scss';
import {TableCard} from "../../generic/cards"
import dayjs from "dayjs";
import {useDefaultEndpoints} from "../../../lib/api/useDefaultEndpoints";
import {ModalConfirmation} from "../../generic/modals";
import TransferDestinationTable from "./TransferDestinationTable";
import {useTransferSlot} from "../../../lib/utils/hooks/useTransferSlot";
import Header from "../../../components/common/formElements/Header";

const TransferSlot = ({createTranslatedBreadcrumbsAndTitle}) => {
    let history = useHistory();
    let {slot_url, url, event_url} = useParams();
    const {t, language} = i18next;
    const [activeTab, setActiveTab] = useQueryParam('t',  StringParam);
    const {state, selectedRows, currentSlotStatus, textBtn, isModalOpen, toggleModal,
        handleConfirmTransfer, openTransferModal, findSlotsWithSorting, calculateTotalPaidForLength, getSlotStatus,
        handleSelect} = useTransferSlot(slot_url);
    const {findAndCountEntries} = useOrdersApi('orders');
    const getBases = useDefaultEndpoints('bases').getEntries;
    const customFilters = {};
    const additionalForProductFields = {};
    const [bases, setBases] = useState([]);

    let presetFilters = {
        base_id: state.event_id?.base_id,
        event_id: state.event_id?.id,
    }

    const [selectedBase, setSelectedBase] = useState(presetFilters.base_id)
    const [selectedEvent, setSelectedEvent] = useState(presetFilters.event_id)
    const [daysFilter, setDaysFilter] = useState({
        from: dayjs().startOf('day').local().format('YYYY-MM-DD'),
        to: dayjs().startOf('day').add(1, 'M').local().format('YYYY-MM-DD')
    })

    const chooseProductFieldSet = () => {
        return getSlotSet;
    }

    const filters = {
        master_order_null: true,
        has_paid: true,
        slot_id: state.id
    }

    const filtersTransfer = {
        name_ncontains: 'delete',
        'event_id.base_id': selectedBase,
        event_id: selectedEvent,
        start_date_gte: daysFilter.from,
        end_date_lte: daysFilter.to
    };

    useEffect(() => {
        const mapper = {
            url: {ru: state.base?.name || '', en: url},
            event_url: {ru: state.event_id?.name || '', en: event_url},
            slot_url: {ru: `${t('bases.base.slotLowercase')} ${fullTimeToShort(state.start_time)} - ${fullTimeToShort(state.end_time)}` || '', en: slot_url}
        }
        if (state.base?.id) {
            createTranslatedBreadcrumbsAndTitle
            && createTranslatedBreadcrumbsAndTitle(mapper, mapper)
        }
    }, [slot_url, url, event_url, state.base?.id, language])

    useEffect(() => {
        if (!activeTab) setActiveTab('users', 'replaceIn');

        if (activeTab)
            setActiveTab(activeTab, 'replaceIn')
    }, [history.location.pathname, url, state.reload])

    useEffect(() => {
        getBases({_sort:'base_order:asc', is_archived: false}).then(res => setBases(() => res))
    }, [])

    if (state.loading) return <Loader/>

    return (
         <TableCard>
            <Header title={t("common.productOrderList.currentSlots")}/>
            {!filters.slot_id
                ? <Loader/>
                : <Row className={'mb-5'}>
                    <Col>
                        <div className={'display-4 card-title'}>
                            {t('common.productOrderList.transfer')}
                            {selectedRows.length > 0 && (
                                <span className="ml-1"> ({selectedRows.length})</span>
                            )}
                        </div>
                    </Col>
                    <Col xs={12}>
                        <DataTable
                            findAndCount={findAndCountEntries}
                            filters={{...filters, ...customFilters}}
                            fields={[
                                ...chooseProductFieldSet()({...additionalForProductFields}),
                            ]}
                            sortField="created_at"
                            sortDir="desc"
                            name={"slots_orders-list"}
                            reload={state.reload}
                            rowClass={res => {
                                if (res.paid_for_ids?.length > 1)
                                    return ''
                            }}
                            multipleSelection={true}
                            onMultipleSelect={handleSelect}
                            onMultipleAllSelect={handleSelect}
                        />
                    </Col>
                </Row>
            }
            {selectedRows.length
                ? <>
                    <ModalConfirmation onClose={toggleModal} isOpen={isModalOpen}
                                       onConfirm={handleConfirmTransfer}
                                       isConfirm={currentSlotStatus === 'transfer'}
                                       hasConfirm={currentSlotStatus === 'transfer'}
                                       confirmButtonText={t('common.forms.movePaymentModal.yes')}
                                       text={textBtn}
                                       title={t('common.forms.movePaymentModal.ordersMoving')}
                                       timer={3}
                    />
                    <Header title={t("common.productOrderList.placeTransfer")}/>
                    <TransferDestinationTable
                        selectedBase={selectedBase}
                        setSelectedBase={setSelectedBase}
                        selectedEvent={selectedEvent}
                        setSelectedEvent={setSelectedEvent}
                        daysFilter={daysFilter}
                        setDaysFilter={setDaysFilter}
                        bases={bases}
                        filtersTransfer={filtersTransfer}
                        findSlotsWithSorting={findSlotsWithSorting}
                        calculateTotalPaidForLength={calculateTotalPaidForLength}
                        getSlotStatus={getSlotStatus}
                        openMoveTransferModal={openTransferModal}
                        state={state}
                    />
                </>
                : <Header title={t("common.forms.movePaymentModal.selectionOrders")}/>
            }
        </TableCard>
    )
}

export default TransferSlot